require('slick-carousel');
/* eslint-disable import/no-unresolved */
const preferences = require('../preferences');

function headerInfoSlider() {
    const headerInfoWrapper = $('.headerInfoSlick');
    const initialConfig = {
        infinite: false,
        arrows: false,
        useTransform: false,
        autoplay: preferences.slider.autoplayHeaderInfo,
        fade: true,
        easing: 'swing',
        vertical: preferences.slider.vertical,
        rows: 1,
        autoplaySpeed: preferences.slider.autoplaySpeedHeaderInfo,
        dots: false,
        centerMode: true,
        slidesToShow: 1,
    };

    const config = Object.assign(initialConfig);

    if (headerInfoWrapper.length && !headerInfoWrapper.hasClass('slick-initialized')) {
        // eslint-disable-next-line no-unused-vars
        headerInfoWrapper.on('init', (event, slick, currentSlide, nextSlide) => {
            headerInfoWrapper.addClass('loaded');
        });
        headerInfoWrapper.slick(config);
    } else if (headerInfoWrapper.length && !headerInfoWrapper.hasClass('loaded')) {
        headerInfoWrapper.slick('refresh');
    }
}

export default () => {
    headerInfoSlider();
};
